import React from 'react';
import { motion } from 'framer-motion';
import { Coffee, Clock, Activity, Moon, ArrowRight } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full bg-warm-gray py-16 px-6 md:py-24" data-id="element-76">
      <div className="max-w-reading mx-auto" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-78">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4 font-serif" data-id="element-79">
            The Quiet Bladder Reset is built for one thing:
          </h2>
          <p className="text-xl md:text-2xl text-sage-dark font-bold mb-8 font-serif" data-id="element-80">
            Get you back a solid, uninterrupted block of sleep.
          </p>

          <div className="mb-12 text-lg text-charcoal/80 space-y-2" data-id="element-81">
            <p data-id="element-82">Not "perfect nights forever."</p>
            <p data-id="element-83">Not miracle claims.</p>
            <p data-id="element-84">A real, felt win:</p>
          </div>

          <blockquote className="text-xl md:text-2xl font-serif text-charcoal italic border-l-4 border-sage pl-6 py-4 mb-16 bg-white/50 rounded-r-lg" data-id="element-85">
            "You go to bed… and you stay asleep long enough to actually recover.
            That's the moment your whole week changes."
          </blockquote>

          <div className="mb-12" data-id="element-86">
            <h3 className="text-2xl font-bold text-charcoal mb-4 font-serif" data-id="element-87">
              The Unique Mechanism: The 3-Trigger Cut + Timing Protocol
            </h3>
            <p className="text-lg text-charcoal mb-8" data-id="element-88">
              Most men are unknowingly dealing with one (or more) of these
              drivers:
            </p>

            <div className="space-y-6" data-id="element-89">
              <div className="bg-white p-6 rounded-xl shadow-card border border-border-gray/50 flex gap-4" data-id="element-90">
                <div className="flex-shrink-0 mt-1" data-id="element-91">
                  <div className="w-8 h-8 rounded-full bg-sage/20 flex items-center justify-center text-sage-dark font-bold" data-id="element-92">
                    1
                  </div>
                </div>
                <div data-id="element-93">
                  <h4 className="text-lg font-bold text-charcoal mb-2 flex items-center gap-2" data-id="element-94">
                    <Coffee className="w-5 h-5 text-sage" data-id="element-95" /> Inputs that
                    irritate
                  </h4>
                  <p className="text-charcoal/90 leading-relaxed" data-id="element-96">
                    Caffeine, alcohol, salty dinner, carbonation, certain foods
                    that increase urine production late in the day.
                  </p>
                </div>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-card border border-border-gray/50 flex gap-4" data-id="element-97">
                <div className="flex-shrink-0 mt-1" data-id="element-98">
                  <div className="w-8 h-8 rounded-full bg-sage/20 flex items-center justify-center text-sage-dark font-bold" data-id="element-99">
                    2
                  </div>
                </div>
                <div data-id="element-100">
                  <h4 className="text-lg font-bold text-charcoal mb-2 flex items-center gap-2" data-id="element-101">
                    <Clock className="w-5 h-5 text-sage" data-id="element-102" /> Timing mistakes
                  </h4>
                  <p className="text-charcoal/90 leading-relaxed" data-id="element-103">
                    Not drinking "too much water" — drinking it at the wrong
                    time, then panicking and cutting fluids the wrong way.
                  </p>
                </div>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-card border border-border-gray/50 flex gap-4" data-id="element-104">
                <div className="flex-shrink-0 mt-1" data-id="element-105">
                  <div className="w-8 h-8 rounded-full bg-sage/20 flex items-center justify-center text-sage-dark font-bold" data-id="element-106">
                    3
                  </div>
                </div>
                <div data-id="element-107">
                  <h4 className="text-lg font-bold text-charcoal mb-2 flex items-center gap-2" data-id="element-108">
                    <Activity className="w-5 h-5 text-sage" data-id="element-109" /> Fluid shift from
                    the legs
                  </h4>
                  <p className="text-charcoal/90 leading-relaxed" data-id="element-110">
                    Fluid pools in your legs during the day. When you lie down,
                    your body processes it… at night.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-charcoal text-warm-white p-8 rounded-xl shadow-lg mb-12" data-id="element-111">
            <div className="flex items-start gap-4" data-id="element-112">
              <Moon className="w-8 h-8 text-amber flex-shrink-0 mt-1" data-id="element-113" />
              <div data-id="element-114">
                <h4 className="text-xl font-bold mb-4 font-serif text-amber" data-id="element-115">
                  And there's a fourth factor that makes everything confusing:
                </h4>
                <p className="text-lg leading-relaxed opacity-90 mb-4" data-id="element-116">
                  Sometimes you wake first… then pee because you're awake.
                </p>
                <p className="text-lg leading-relaxed opacity-90" data-id="element-117">
                  So you blame your bladder when your sleep is the first domino.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center" data-id="element-118">
            <p className="text-xl text-charcoal font-medium mb-8" data-id="element-119">
              The Quiet Bladder Reset shows you how to test this calmly —
              without turning your life into a strict prison.
            </p>

            <button onClick={() => {
            document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }} className="w-full md:w-auto bg-amber hover:bg-amber-hover text-white text-lg font-bold py-3 px-8 rounded-lg shadow-md transition-all transform hover:scale-[1.02] flex items-center justify-center gap-2 mx-auto" data-id="element-120">
              Get the Reset — $6.36 <ArrowRight className="w-5 h-5" data-id="element-121" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}